import httpService from "./httpService";
import type { ProviderNotificationRoster } from "../types/providerNotificationRosters";

class AdminProviderNotificationRostersService {
  async getProviderRoster(providerId: number, signal?: AbortSignal): Promise<ProviderNotificationRoster> {
    const response = await httpService.get<ProviderNotificationRoster>(
      `/v3/admin/providers/${encodeURIComponent(providerId)}/notification-roster`,
      { requiresAuth: true, requestScope: "actor", cache: "no-store", signal }
    );
    return response.data;
  }
}

export default new AdminProviderNotificationRostersService();
